import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  subscribeToBrowserNotifications(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Browser/Subscribe?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  unsubscribeFromBrowserNotifications(data) {
    var headers: any = this.helpersService.getNewApiHeaders();
    headers.body = data;

    return this.http
      .delete(
        this.env.url + `/Browser/UnSubscribe?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  checkBrowserNotificationSubscription(EndPoint) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Browser/CheckSubscription?code=${this.env.key}&EndPoint=${EndPoint}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getUnreadNotifications(PartnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Messaging/Partner/${PartnerID}/Unread?code=${this.env.key}&page=1&limit=20`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getAllIncommingNotifications(PartnerID, Page, Limit, Search) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Messaging/Partner/${PartnerID}/All?code=${this.env.key}&page=${Page}&limit=${Limit}&search=${Search}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getAllIncommingNotifications_V2(partners, Page, Limit, Search) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Messaging/Partner/${this.helpersService.getPartnerId()}/AllV2?code=${this.env.key}&page=${Page}&limit=${Limit}&search=${Search}&Partners=${partners}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getJobCardNotifications(PartnerID, JobCardID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Messaging/Partner/${PartnerID}/JobCard/${JobCardID}?code=${this.env.key}&page=1&limit=20`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getJobCardNotificationsV2(PartnerID, JobCardID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Messaging/V2/Partner/${PartnerID}/JobCard/${JobCardID}?code=${this.env.key}&page=1&limit=20`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  markMessageRead(PartnerID, MessageID) {
    if(PartnerID == null || PartnerID == undefined)
      {
        return throwError('Partner not set');
      }

    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
          `/v4.0/Messaging/Partner/${PartnerID}/Read/${MessageID}?code=${this.env.key}&page=1&limit=100`,
        {},
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getAvailableSMSCredits(PartnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Messaging/Partner/${PartnerID}/Credits?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getTransactionSummary(PartnerID, ShowOnlyCredits) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Messaging/Partner/${PartnerID}/TransactionSummary?code=${this.env.key}&ShowOnlyCredits=${ShowOnlyCredits}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getAthleteJobMessages(AthleteID, JobcardID, PartnerID) {
    return this.http
      .get(
        this.env.url +
          `/v4.0/Messaging/Athlete/${AthleteID}/Partner/${PartnerID}/JobCard/${JobcardID}?code=${this.env.key}`,
        {},
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  createJobCardMessage(AthleteID, JobcardID, PartnerID, Message) {
    var data = {
      PartnerID: PartnerID,
      AthleteID: AthleteID,
      JobCardID: JobcardID,
      Message: Message,
    };

    return this.http
      .post(
        this.env.url +
          `/v4.0/Messaging/Athlete/CreateJobCardMessage?code=${this.env.key}`,
        data,
        {},
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getBundles() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/v4.0/Messaging/BundlePackages?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getBundlesPerCountry(Country) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Messaging/BundlePackages?code=${this.env.key}&Country=${Country}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  deleteBundle(ID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
          `/v4.0/Messaging/BundlePackage/${ID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addBundle(bundle) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/v4.0/Messaging/BundlePackage?code=${this.env.key}`,
        bundle,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  sendSMSMessage(PartnerID, UserID, CreatedBy, Title, Message, JobcardNo) {
    var data = {
      PartnerID,
      UserID,
      CreatedBy,
      Title,
      Message,
      JobcardNo,
    };
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/v4.0/Messaging/Partner/SendSMS?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  sendGlobalPushNotification(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/pushnotifications/global?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  checkIfWhatsappCustomMessageWindowOpen(partnerID, type, ID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/WhatsAppForBusiness/Partner/${partnerID}/CheckIfWhatsappCustomMessageWindowOpen?code=${this.env.key}&Type=${type}&ID=${ID}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
  
  sendInitiateWhatsappChatTemplate(partnerID, type, ID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/WhatsAppForBusiness/Partner/${partnerID}/SendInitiateChatTemplate?code=${this.env.key}&Type=${type}&ID=${ID}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
}
